import Step6Widget from './Step6Widget'

export default Step6Widget
